import type { Nullable } from "../../../../../typescript"
import type { Engine } from "../../../engine/Engine.type"
import getPlayerGraphNode from "../../../engine/PlayerGraphNode/getPlayerGraphNode"
import type { BaseEntity } from "../../../entity/BaseEntity"
import type { Entity } from "../../../entity/index"
import { PlayerGameStatus } from "../../../player/PlayerGameStatus"
import type { PlayerId } from "../../../player/PlayerId"

export default function checkLostLastEntityWinCondition(
  engine: Engine,
  losingPlayerId: Nullable<PlayerId>
) {
  if (!losingPlayerId) {
    return
  }

  const losingPlayer = getPlayerGraphNode(engine, losingPlayerId)

  const playerEnts = losingPlayer.ents().filter((ent: Entity) => !(ent as BaseEntity).taxi_id)

  if (playerEnts.length === 0) {
    // losingPlayerId has no entities left, so they are lost
    losingPlayer().game_status = PlayerGameStatus.Lost
    return
  }
}